import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { FieldsAPI } from 'api/fields';
import { FieldsObjectTypeForApi } from 'api/fields/fields';
import { useFilterPointsFieldsFromTaskFields } from 'hooks/use-filter-point-fields-from-task-fields';
import { ALL_FIELDS_QUERY_KEY, fieldsQueryKeys, objectSubTypes, objectTypes, oneDay, TASK_FIELDS_QUERY_KEY } from 'queries/constants';
export const useAllFieldsBaseQuery = (queryOptions = {})=>{
    return useQuery(ALL_FIELDS_QUERY_KEY, async ()=>{
        return FieldsAPI.getAllFields().then((fields)=>fields.reduce((acc, field)=>acc.concat(field.fields), []));
    }, {
        staleTime: oneDay,
        ...queryOptions
    });
};
export const useTaskFieldsBaseQuery = (queryOptions = {})=>{
    const { filterPointsFieldsFromTaskFields } = useFilterPointsFieldsFromTaskFields();
    const selectWithPointsFilter = useCallback((data)=>filterPointsFieldsFromTaskFields(data), [
        filterPointsFieldsFromTaskFields
    ]);
    return useQuery(TASK_FIELDS_QUERY_KEY, async ()=>{
        var _resp_fields;
        const resp = await FieldsAPI.getFieldsByObjectType(FieldsObjectTypeForApi.Tasks);
        if (!(resp === null || resp === void 0 ? void 0 : (_resp_fields = resp.fields) === null || _resp_fields === void 0 ? void 0 : _resp_fields.length)) {
            return [];
        }
        return resp.fields;
    }, {
        ...queryOptions,
        select: selectWithPointsFilter
    });
};
export const useAllFieldsQueryV2 = ({ objectType, objectSubType }, queryOptions = {})=>{
    return useQuery([
        ...fieldsQueryKeys[objectType],
        objectSubType !== null && objectSubType !== void 0 ? objectSubType : 'DEFAULT'
    ], async ()=>{
        var _ref;
        const data = await FieldsAPI.getFieldsByObjectType(objectTypes[objectType], objectSubType ? objectSubTypes[objectSubType] : undefined);
        return (_ref = data === null || data === void 0 ? void 0 : data.fields) !== null && _ref !== void 0 ? _ref : [];
    }, queryOptions);
};
